module.exports = __webpack_public_path__ + "img/73.cb0ad490.jpg";